<template>
  <div ref="media-container" :class="['hero-item', { 'hero-item--background-image': isIe }]">
    <!-- video block  -->
    <oie-hero-video v-if="showVideo" :item="item"></oie-hero-video>

    <!-- image block  -->
    <template v-else>
      <img
        v-if="showImage"
        :src="`${item.image}?width=1280`"
        :srcset="srcsetCreate(item.image)"
        :alt="item.imageAltText"
        class="hero-item__image">
    </template>

    <div :class="['hero-item__container', heroPlacementClass(item.horizontalPlacement)]">
      <div class="hero-item__content">
        <div class="hero-item__content-left">
          <h2 class="hero-item__title">
            {{ item.title }}
          </h2>

          <p v-if="item.text" class="hero-item__text">
            {{ item.text }}
          </p>
        </div>

        <a :href="item.callToActionUrl" class="hero-item__link"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true }
  },
  data: () => ({
    isIe: false
  }),
  computed: {
    showVideo() { return this.item.video && !this.isIe },
    showImage() { return !this.isIe }
  },
  mounted() {
    if ('objectFit' in document.documentElement.style === false) {
      this.isIe = true
      const parent = this.$refs['media-container']
      parent.style.backgroundImage = `url(${this.item.image}?width=1280)`
    }
  },
  methods: {
    heroPlacementClass(placement) {
      return `hero-item__container--${placement}`
    },
    srcsetCreate(imageUrl) {
      return ['640', '760', '1024', '1280', '1536', '1800', '2100'].map((size) => {
        return `${imageUrl}?width=${size} ${size}w`
      }).join(', ')
    }
  }
}
</script>

<style lang="scss">
.hero-item {
  position: relative;
}

.hero-item:hover {
  cursor: pointer;
}

.hero-item--background-image {
  background-size: cover;
  background-repeat: no-repeat;
}

.hero-item__image, .hero-video__video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.hero-item__container {
  @include container;
  display: flex;
  align-items: center;
  min-height: 15rem;
  height: 100%;
  padding-top: measure(full);
  padding-bottom: measure(full);

  @include media(small) {
    min-height: 31.25rem;
    padding-top: measure(double);
    padding-bottom: measure(double);
  }
}

.hero-item__container--left {
  justify-content: flex-start;
}

.hero-item__container--center {
  justify-content: center;
}

.hero-item__container--right {
  justify-content: flex-end;
}

.hero-item__content {
  display: flex;
  align-items: center;
  max-width: 24rem;
  padding: measure(half);
  background-color: rgba(51,51,51,.8);
  color: white;
  border-bottom: .5rem solid #006db6;

  @include media(small) {
    max-width: 25rem;
    padding: measure(full);
  }

  @include media(medium) {
    max-width: 75ch;
  }
}

.hero-block__caruosel-container .hero-item__content {
  @include media(small) {
    margin-right: calc(#{measure(double) + #{measure(full)}});
    margin-left: calc(#{measure(double) + #{measure(full)}});
  }

  @include media(x-large) {
    margin-right: 0;
    margin-left: 0;
  }
}

.hero-item__title {
  @include h1-semi-bold;
  line-height: 1.2;
  margin: 0;
}

.hero-item__text {
  grid-area: text;
  margin-top: measure(quarter);
  margin-bottom: 0;

  @include media(medium) {
    max-width: 28.125rem;
  }
}

.hero-item__link {
  flex-shrink: 0;
  margin-left: measure(half);
  width: 0.75rem;
  height: 1.0625rem;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='23' viewBox='0 0 16 23' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.66 11.894L.88 3 2.9.78l12.22 11.114L2.908 23 .89 20.78z' fill='%23FFFFFF' fill-rule='nonzero'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 200ms;

  @include media(small) {
    width: 0.875rem;
    height: 1.625rem;
  }

  @include media(medium) {
    margin-left: measure(full);
  }
}

.hero-item__link:hover {
  cursor: pointer;
}

.hero-item__link::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
